// frontend/src/components/regulatory/NotExhaustiveBanner.tsx
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Persistent early-warning framing banner.
 * No close / dismiss button — always visible at the top of the Regulatory Watch page.
 * Copy mirrors HLD §"Assistant, not a guarantee".
 */
export function NotExhaustiveBanner(): JSX.Element {
  const { t } = useTranslation("regulatory");

  return (
    <div
      role="note"
      aria-label={t("banner_title")}
      className="flex gap-3 rounded-[11px] border border-[#fde9c8] bg-amber-soft px-4 py-3 text-sm"
    >
      <AlertTriangle
        className="mt-0.5 h-4 w-4 shrink-0 text-amber-600"
        aria-hidden
      />
      <div className="min-w-0">
        <p className="font-semibold text-amber-800">{t("banner_title")}</p>
        <p className="mt-0.5 text-amber-700">{t("banner_body")}</p>
      </div>
    </div>
  );
}
